import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environment';
import { AppModule } from '@app/app.module';
import { WindowWithUser } from '@longnecktech/splash-commons-fe';
import * as Sentry from '@sentry/angular';

const url = new URL(window.location.href);

function getQueryParams() {
  const queryParams = new URLSearchParams(url.search);
  return {
    token: queryParams.get('token') ?? '',
    instance: queryParams.get('instance') ?? '',
    language: queryParams.get('language') ?? '',
  };
}

const { token, instance, language: urlLang } = getQueryParams();

if (token) {
  const selectedLanguage = urlLang || decodeTokenLang(token) || 'en';

  fetch(`${environment.backendUrl}/api/public/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': selectedLanguage,
    },
    body: JSON.stringify({ token, instance, language: selectedLanguage }),
  })
    .then((response) => response.json())
    .then((data) => {
      Sentry.init({
        dsn: 'https://c1eaa4279d004aef3b0e886f00f3c38a@o4511632967401472.ingest.de.sentry.io/4511659124916304',
        environment: environment.name,
        integrations: [Sentry.replayIntegration()],
        replaysOnErrorSampleRate: 1.0,
      });

      (window as WindowWithUser).user = data;
      platformBrowserDynamic()
        .bootstrapModule(AppModule, {
          applicationProviders: [provideZoneChangeDetection()],
        })
        .catch((err) => console.error(err));
    })
    .catch((error) => console.error('Authentication error:', error));
} else {
  console.warn('No token!');
}

function decodeTokenLang(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.language ?? null;
  } catch (err) {
    console.warn('Failed to decode JWT', err);
    return null;
  }
}
